import { render, staticRenderFns } from "./qrCodeDotsAdv.vue?vue&type=template&id=c1d49c66&scoped=true"
import script from "./qrCodeDotsAdv.vue?vue&type=script&lang=js"
export * from "./qrCodeDotsAdv.vue?vue&type=script&lang=js"
import style0 from "./qrCodeDotsAdv.vue?vue&type=style&index=0&id=c1d49c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d49c66",
  null
  
)

export default component.exports